import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const StyledButton = styled.button`
  border: ${props => `1px solid ${props.theme.LABEL === 'catapult' ? props.theme.PRIMARY : props.theme.WARNING}`};
  color: ${props => (props.background ? props.theme.WHITE : props.theme.PRIMARY)};
  padding: ${props => (props.isSmall ? '8px 10px' : '8px 30px')};
  outline: none;
  display: flex;
  align-items: center;
  cursor: pointer;
  background: ${props => props.background};
  font-size: 14px;
  font-weight: ${props => (props.background ? '600' : '')};

  & svg {
    margin-right: 5px;
  }
`;

function SSOButton({
  backgroundColor, icon: IconComponent, isSmall, onClick, text, id,
}) {
  return (
    <StyledButton
      id={`${id}.Button`}
      type="button"
      onClick={onClick}
      background={backgroundColor}
      isSmall={isSmall}
    >
      {IconComponent && <IconComponent />}
      <span id={`${id}.Text`}>{text}</span>
    </StyledButton>
  );
}

SSOButton.propTypes = {
  backgroundColor: PropTypes.string,
  id: PropTypes.string,
  icon: PropTypes.func,
  isSmall: PropTypes.bool,
  onClick: PropTypes.func,
  text: PropTypes.string.isRequired,
};

SSOButton.defaultProps = {
  backgroundColor: '',
  isSmall: false,
};

export default SSOButton;
